var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 841.9 595.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#051C3C",
    cx: 421.5,
    cy: 297.8,
    r: 220.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F9A61F",
    d: "M338.2,446.9V144.6c0-0.1,0-0.1,0.1-0.1h77.3c0.5,0,0.9,0.4,0.9,0.9v35.9c0,0.1-0.6,0.4-1.5,0.8 c-3.5,1.7-11.9,5.1-11.9,5.1c-0.5,0-0.9-0.4-0.9-0.9V162c0-0.5-0.4-0.9-0.9-0.9h-48.1c-0.4,0-0.8,0.4-0.8,0.8 c0,0-0.8,285.1-0.9,285.1L338.2,446.9C338.3,447,338.2,447,338.2,446.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9A61F",
    d: "M338.2,447h39.5c0.4,0,0.8-0.4,0.8-0.8v-15.8c0,0,0,0,0-0.1c-0.1-0.7-1-13,5.9-13c6.9,0,6,11.2,5.9,11.8 c0,0,0,0,0,0.1v17c0,0.4,0.4,0.8,0.8,0.8h66c0.4,0,0.8-0.4,0.8-0.8c0,0-9-15.8-9.5-15.8h-42.7c-0.4,0-2.4,0.4-2.4,0v-11.9 c0,0,1.2-15.8-21.4-14.2c-16.6,1.2-16.6,14.2-16.6,14.2v11.1c0,0.4-0.4,0.8-0.8,0.8h-26.5V447z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9A61F",
    d: "M547,446.2c0,0-13.8-15.8-14.2-15.8h-39.1c-0.4,0-1.2-0.8-1.2-1.2c-0.5-6.3-8.6-46.9-36.8-65.2 c-23.7-15.4-64.8-14.3-71.4-13.2c-0.5,0.1-0.9-0.3-0.9-0.8V203.8c0-0.4-11-4.7-11-4.7c-0.5,0-0.8,0.4-0.8,0.8l-1.2,166.7 c0,0.5,0.5,0.9,1,0.8c6.6-1.3,58.3-5.6,77.4,9.7c29.7,23.7,30.3,62,30.8,69.3c0,0.4,0.4,0.7,0.8,0.7h66.1 C546.7,447,547,446.6,547,446.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9A61F",
    d: "M380.6,174.2h7.9c0.4,0,0.8-0.4,0.8-0.8v-5.5c0-0.4-0.4-0.8-0.8-0.8h-7.9c-0.4,0-0.8,0.4-0.8,0.8v5.5 C379.8,173.8,380.1,174.2,380.6,174.2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2907bc39fea43536e99fd8601d5e4fb2.svg";
export { ForwardRef as ReactComponent };